/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-inner-declarations */

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    if ('IntersectionObserver' in window) {
      function handleIntersection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Item has crossed our observation threshold

            const viewportWidth = window.innerWidth;

            if (viewportWidth >= 992) {
              entry.target.style.backgroundImage = `url(${entry.target.dataset.desktopBgimage})`;
            } else {
              entry.target.style.backgroundImage = `url(${entry.target.dataset.mobileBgimage})`;
            }
            // Job done for this item - no need to watch it!
            observer.unobserve(entry.target);
          }
        });
      }

      const backgroundElements = document.querySelectorAll('.widget-section-background');
      const observer = new IntersectionObserver(handleIntersection, { rootMargin: '100px' });
      backgroundElements.forEach((backgroundElement) => observer.observe(backgroundElement));
    } else {
      // No interaction support? Load all background images automatically
      const backgroundElements = document.querySelectorAll('.widget-section-background');
      backgroundElements.forEach((element) => {
        const viewportWidth = window.innerWidth;

        if (viewportWidth >= 992) {
          element.target.style.backgroundImage = `url(${element.target.dataset.desktopBgimage})`;
        } else {
          element.target.style.backgroundImage = `url(${element.target.dataset.mobileBgimage})`;
        }
      });
    }
  });
}
